
(function () {
  'use strict';

  /*
    BOOKSY grid-sorrend vezérlő (kollekció + keresés).

    SZŰRÉS-JAVÍTÁS 2026-10-04 — tulaj-döntés: „a választott rendezést tiszteljük”.
    - Ha a vevő rendezést választott (URL: sort_by) — kollekción ÉS keresésen —, a rács PONTOSAN a Shopify
      sorrendje: nincs raktáron-elöl átrendezés és nincs elfogyott-hátrasorolás. (Eddig: keresésen sort_by mellett
      is átrendezett; a hátrasorolás pedig oldalanként futott, ezért ár/cím szerint a lapozás eltörte a sorrendet.)
    - sort_by NÉLKÜL (alapnézet) oldalanként raktáron-elöl rendez, az elfogyottak a lap végére kerülnek; a
      legördülő ezt „Raktáron lévők elöl” néven mutatja (collection-grid.liquid).
    - Kézi sorrendű (kurált: Top 50, olvasói ajánlások) gyűjtemény: nincs raktáron-elöl rendezés (mint eddig);
      az elfogyottak hátrasorolása marad (mint eddig) — itt a viselkedés változatlan.
    - Az elfogyott-hátrasorolás (korábban booksy-oos-pushback.liquid) ide került, és AJAX-szűrés után
      (theme.js 'collection:reloaded') az alap-sorrend és a „Kiadás éve” vezérlő is újra lefut / újra bekötődik.
    - A „Rendezés” legördülőt itt kezeljük, kollekción és keresésen egyformán: sort_by beállítása (vagy a
      „Raktáron lévők elöl” választásnál törlése), page törlése; minden más paraméter (q, type, filter.*) marad.
      (A keresés szándékosan nem kapja meg a theme.js gyűjtemény-AJAX-át — main-search.liquid, 2026-04-29.)
  */

  var MAX_PASSES = 4;     // multi-pass plafon a keresési teljes-betöltésre
  var MAX_PAGES = 12;     // oldal/pass plafon
  var MAX_ITEMS = 600;    // össz-kártya plafon (memória/payload védelem)
  var AUTOLOAD_MAX = 300; // e fölött a keresést NEM töltjük be automatikusan
  var PAGE_STRIDE = 10000; // a szerver-sorrend kulcsa: oldal * PAGE_STRIDE + hely az oldalon

  // Megosztott állapot: 'base' (alap-sorrend) | 'asc' | 'desc' (kiadási év)
  var state = { mode: 'base' };

  // ── Szabály ───────────────────────────────────────────────────────────
  function explicitSort() {
    var v = new URLSearchParams(window.location.search).get('sort_by');
    return !!(v && String(v).trim());
  }
  function mainWrap() { return document.querySelector('.collection-grid__wrapper'); }
  function isManual() {
    var w = mainWrap();
    return !!(w && w.getAttribute('data-bky-default-sort') === 'manual');
  }
  function policy() {
    var explicit = explicitSort();
    return {
      stockFirst: !explicit && !isManual(), // raktáron-elöl: csak választott rendezés nélkül, nem kurált listán
      soldOutLast: !explicit                // elfogyott hátra: csak választott rendezés nélkül
    };
  }

  // ── Grid ─────────────────────────────────────────────────────────────
  function mainGrid() {
    var w = mainWrap();
    if (!w) return null;
    var g = w.querySelector('.grid.grid--uniform');
    return (g && g.querySelector(':scope > .grid-product')) ? g : null;
  }
  function cardsOf(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-product'));
  }
  function pageNo(url) {
    try {
      var n = parseInt(new URL(url, window.location.href).searchParams.get('page'), 10);
      return n > 0 ? n : 1;
    } catch (e) { return 1; }
  }
  function stamp(cards, page) {
    cards.forEach(function (c, i) {
      if (!c.hasAttribute('data-bky-ord')) c.setAttribute('data-bky-ord', String(page * PAGE_STRIDE + i));
    });
  }
  function ordOf(c) { return parseInt(c.getAttribute('data-bky-ord'), 10) || 0; }
  function isSoldOut(c) { return !!c.querySelector('.grid-product__tag--sold-out'); }

  // ── Bolti-készlet prioritás ───────────────────────────────────────────
  function stockPriority(card) {
    var badge = card.querySelector('.stock-badge');
    if (!badge) return { type: 3, days: 999 };
    var cls = badge.className;
    var type = 3;
    if (cls.indexOf('instock') > -1) type = 0;
    else if (cls.indexOf('partner') > -1) type = 1;
    else if (cls.indexOf('supplier') > -1) type = 2;
    var deliveryEl = badge.querySelector('.stock-badge__delivery');
    var days = 999;
    if (deliveryEl) {
      var m = deliveryEl.textContent.match(/(\d+)-(\d+)/);
      if (m) days = parseInt(m[2], 10);
      else { var m2 = deliveryEl.textContent.match(/(\d+)/); if (m2) days = parseInt(m2[1], 10); }
    }
    return { type: type, days: days };
  }
  function byStock(a, b) {
    var pa = stockPriority(a), pb = stockPriority(b);
    if (pa.type !== pb.type) return pa.type - pb.type;
    return pa.days - pb.days;
  }

  // ── Keresési relevancia (10-31, mélyaudit) ────────────────────────────
  // A Shopify-keresés elgépelés-tűrő, ezért rokon szavakra is talál (catan → cain, cat); a raktáron-elöl rendezés ezeket
  // a pontos találatok elé tette (a „catan” keresés első 12 kártyájából 9 irreleváns volt). Kereséskor ezért előbb azok
  // a kártyák jönnek, amelyek CÍME vagy SZERZŐJE minden keresőszót tartalmaz (ékezet nélkül), és csak ezen belül dönt
  // a készlet. Ha egy kártya sem egyezik, mind ugyanabba a szintbe esik → a régi viselkedés marad.
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  var QUERY_WORDS = (function () {
    if (!/(^|\/)search(\/|$)/.test(window.location.pathname)) return [];
    return norm(new URLSearchParams(window.location.search).get('q')).split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 2; });
  })();
  function relTier(card) {
    if (!QUERY_WORDS.length) return 0;
    var t = card.getAttribute('data-bky-cim');
    if (t === null) {
      // cím + szerző: szerzőre keresve a szerző saját (raktári) könyvei ne kerüljenek a róla szóló könyvek mögé
      var el = card.querySelector('.grid-product__title'), v = card.querySelector('.grid-product__vendor');
      t = norm((el ? el.textContent : '') + ' ' + (v ? v.textContent : ''));
      card.setAttribute('data-bky-cim', t);
    }
    return QUERY_WORDS.every(function (w) { return t.indexOf(w) > -1; }) ? 0 : 1;
  }

  // Alap-sorrend: [elfogyott hátra] → [keresésnél: címben egyező elöl] → [raktáron elöl] → a szerver sorrendje (data-bky-ord).
  // Választott rendezésnél mindkét kapcsoló ki → tisztán a szerver sorrendje.
  function baseCmp(pol) {
    return function (a, b) {
      if (pol.soldOutLast) {
        var sa = isSoldOut(a), sb = isSoldOut(b);
        if (sa !== sb) return sa ? 1 : -1;
      }
      if (pol.stockFirst) {
        var ra = relTier(a), rb = relTier(b);
        if (ra !== rb) return ra - rb;
        var s = byStock(a, b);
        if (s) return s;
      }
      return ordOf(a) - ordOf(b);
    };
  }

  // ── Kiadási év ────────────────────────────────────────────────────────
  function yearOf(card) {
    var v = card.getAttribute('data-year');
    if (!v) return null;
    var n = parseInt(v, 10);
    return isNaN(n) ? null : n;
  }
  function yearCmp(dir, pol) {
    var base = baseCmp(pol);
    return function (a, b) {
      if (pol.soldOutLast) {
        var sa = isSoldOut(a), sb = isSoldOut(b);
        if (sa !== sb) return sa ? 1 : -1;
      }
      var ya = yearOf(a), yb = yearOf(b);
      if (ya === null && yb !== null) return 1;
      if (yb === null && ya !== null) return -1;
      if (ya !== null && yb !== null && ya !== yb) return dir === 'asc' ? ya - yb : yb - ya;
      return base(a, b);
    };
  }

  // J07 (L013, 10-21): a keresés cikk-/oldal-találatai (.grid-search) a rács VÉGÉRE kerülnek. Eddig a rendezés csak a
  // termékkártyákat fűzte újra a rács végére, így a cikkek az ELEJÉRE csúsztak (360 px-en az első könyv y=2284-nél).
  function cikkekVegere(grid) {
    var cikkek = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-search'));
    if (!cikkek.length) return;
    var utolso = grid.lastElementChild;
    var mar = cikkek.every(function (c, i) { return c === grid.children[grid.children.length - cikkek.length + i]; });
    if (mar && utolso === cikkek[cikkek.length - 1]) return;
    var frag = document.createDocumentFragment();
    cikkek.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);
  }
  function reorder(grid, cmp) {
    var items = cardsOf(grid);
    if (items.length >= 2) {
      var sorted = items.slice().sort(cmp);
      var changed = false;
      for (var i = 0; i < items.length; i++) { if (items[i] !== sorted[i]) { changed = true; break; } }
      if (changed) {
        var frag = document.createDocumentFragment();
        sorted.forEach(function (el) { frag.appendChild(el); });
        grid.appendChild(frag);
      }
    }
    cikkekVegere(grid);
  }

  // ── Vezérlő + teljes-betöltés (keresés/kategória könyv-grideken) ───────
  function bootControls(grid) {
    var wrap = mainWrap();
    var controls = wrap && wrap.querySelector('[data-booksy-year-controls]');
    if (!controls) return;
    if (controls.getAttribute('data-bky-bound') === '1') return; // ugyanarra a DOM-ra egyszer
    controls.setAttribute('data-bky-bound', '1');
    // MOBIL 2. kör (09-26): a szerver könyv-rácsnál már láthatóan rendereli a sávot (CLS) → nem-könyv rácsnál itt rejtjük
    if (!grid || !cardsOf(grid).some(function (c) { return c.getAttribute('data-year'); })) { controls.hidden = true; return; }

    controls.hidden = false;

    var isSearch = /(^|\/)search(\/|$)/.test(window.location.pathname);
    var loaded = false, loadingPromise = null, hitCap = false;
    var seen = {};
    cardsOf(grid).forEach(function (c) { var id = c.getAttribute('data-product-id'); if (id) seen[id] = true; });

    var sortBtns = Array.prototype.slice.call(controls.querySelectorAll('[data-year-sort]'));
    var minInput = controls.querySelector('[data-year-min]');
    var maxInput = controls.querySelector('[data-year-max]');
    var resetBtn = controls.querySelector('[data-year-reset]');
    var statusEl = controls.querySelector('[data-year-status]');
    var countEl = wrap.querySelector('.collection-filter__item--count');

    // J07 (L075): mobilon a vezérlősáv rejtett, ezért a betöltés állapota egy külön, rács fölötti sorban is látszik
    var mobilStatus = null;
    if (/(^|\/)search(\/|$)/.test(window.location.pathname)) {
      mobilStatus = document.createElement('p');
      mobilStatus.className = 'bky-kereso-status';
      mobilStatus.setAttribute('role', 'status');
      mobilStatus.setAttribute('aria-live', 'polite');
      mobilStatus.hidden = true;
      grid.parentNode.insertBefore(mobilStatus, grid);
    }
    function setStatus(t) {
      if (statusEl) statusEl.textContent = t || '';
      if (mobilStatus) { mobilStatus.textContent = t || ''; mobilStatus.hidden = !t; }
    }
    function seenCount() { return Object.keys(seen).length; }
    function hasNextPage() { return !!document.querySelector('.pagination .next a'); }

    function fetchDoc(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status + ' @ ' + url);
        return r.text();
      }).then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    function absorb(doc, page) {
      var incoming = doc.querySelectorAll('.grid-product[data-product-id]');
      var frag = document.createDocumentFragment(), added = 0;
      incoming.forEach(function (c, i) {
        var id = c.getAttribute('data-product-id');
        if (id && !seen[id]) {
          seen[id] = true;
          var node = document.importNode(c, true);
          node.setAttribute('data-bky-ord', String(page * PAGE_STRIDE + i)); // a szerver-sorrend megőrzéséhez
          frag.appendChild(node); added++;
        }
      });
      if (added) grid.appendChild(frag);
      return { pageCards: incoming.length, added: added };
    }
    function pageLink(doc, which) {
      var a = doc.querySelector('.pagination ' + which + ' a');
      return a ? a.getAttribute('href') : null;
    }

    // KERESÉS: könnyű ?view=cards, multi-pass amíg az egyedi halmaz stabil.
    function searchUrl(p) {
      var q = new URLSearchParams(window.location.search);
      q.set('view', 'cards'); q.set('type', 'product'); q.set('page', String(p));
      return window.location.pathname + '?' + q.toString();
    }
    var termekOssz = null; // a ?type=product oldal saját találatszáma (cikkek nélkül) — az 1. lekért oldalról
    function termekSzam(doc) {
      var el = doc.querySelector('.collection-filter__item--count');
      var m = el && el.textContent.replace(/\u00a0/g, ' ').match(/(\d[\d\s.]*)/);
      var n = m ? parseInt(m[1].replace(/[\s.]/g, ''), 10) : NaN;
      return isNaN(n) ? null : n;
    }
    function multiPassSearch() {
      var prev = -1, pass = 0;
      function onePass() {
        if (pass >= MAX_PASSES) return Promise.resolve();
        var before = seenCount();
        var p = 1;
        function nextPage() {
          if (p > MAX_PAGES || seenCount() >= MAX_ITEMS) { if (seenCount() >= MAX_ITEMS) hitCap = true; return Promise.resolve(); }
          var pg = p;
          return fetchDoc(searchUrl(pg)).then(function (doc) {
            if (termekOssz === null) termekOssz = termekSzam(doc);
            var r = absorb(doc, pg);
            setStatus('Találatok betöltése… (' + seenCount() + ')');
            if (r.pageCards === 0) return Promise.resolve(); // túl az utolsó oldalon
            p++; return nextPage();
          }).catch(function () { return Promise.resolve(); });
        }
        return nextPage().then(function () {
          var after = seenCount();
          pass++;
          // J07 (L075): ha a termékek száma már megvan, nincs 2. kör (eddig minden oldalt kétszer kért le)
          // a ?view=cards válaszban nincs számláló → tartalék: a betöltött oldal szerver-oldali találatszáma
          var cel = termekOssz !== null ? termekOssz : reportedCount();
          if (cel !== null && after >= cel) return Promise.resolve();
          if (after === before && pass > 1) return Promise.resolve(); // stabil
          if (after === prev) return Promise.resolve();
          prev = after;
          return onePass();
        });
      }
      return onePass();
    }

    // KATEGÓRIA: stabil lapozás → elég egy menet (next + prev lánc, normál oldalak).
    function chainCollection() {
      function follow(href, which) {
        if (!href || seenCount() >= MAX_ITEMS) { if (seenCount() >= MAX_ITEMS) hitCap = true; return Promise.resolve(); }
        return fetchDoc(href).then(function (doc) {
          absorb(doc, pageNo(href));
          setStatus('Összes találat betöltése… (' + seenCount() + ')');
          return follow(pageLink(doc, which), which);
        }).catch(function () { return Promise.resolve(); });
      }
      return follow(pageLink(document, '.next'), '.next')
        .then(function () { return follow(pageLink(document, '.prev'), '.prev'); });
    }

    // J07 (L138): „termék” (a keresés játékot is ad, nem csak könyvet), és a morzsa is ugyanezt a számot mondja
    function updateCount() {
      var n = seenCount();
      var re = /\d[\d\s.\u00a0]*\s*(találat|termék|könyv|result[s]?)/i;
      if (countEl) countEl.textContent = n + ' termék';
      try { document.title = document.title.replace(re, n + ' termék'); } catch (e) {}
      document.querySelectorAll('.breadcrumb span, .breadcrumb [aria-current]').forEach(function (el) {
        if (!el.children.length && re.test(el.textContent)) el.textContent = el.textContent.replace(re, n + ' termék');
      });
    }

    function ensureLoaded() {
      if (loaded) return Promise.resolve();
      if (loadingPromise) return loadingPromise;
      if (!hasNextPage()) { loaded = true; return Promise.resolve(); } // egy oldal → kész
      setStatus(isSearch ? 'Találatok betöltése…' : 'Összes találat betöltése…');
      loadingPromise = (isSearch ? multiPassSearch() : chainCollection()).then(function () {
        loaded = true;
        document.querySelectorAll('.pagination').forEach(function (p) { p.style.display = 'none'; });
        updateCount();
      });
      return loadingPromise;
    }

    // ── Rendezés + szűrés ───────────────────────────────────────────────
    function applySort() {
      var pol = policy();
      if (state.mode === 'asc' || state.mode === 'desc') reorder(grid, yearCmp(state.mode, pol));
      else reorder(grid, baseCmp(pol));
    }
    function applyFilter() {
      var lo = parseInt(minInput && minInput.value, 10); if (isNaN(lo)) lo = null;
      var hi = parseInt(maxInput && maxInput.value, 10); if (isNaN(hi)) hi = null;
      var active = lo !== null || hi !== null, shown = 0, total = 0;
      cardsOf(grid).forEach(function (c) {
        total++;
        if (!active) { c.style.display = ''; shown++; return; }
        var y = yearOf(c);
        var ok = y !== null && (lo === null || y >= lo) && (hi === null || y <= hi);
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      return { active: active, shown: shown, total: total };
    }
    function hasFilterValue() { return !!((minInput && minInput.value) || (maxInput && maxInput.value)); }
    function updateButtons() {
      sortBtns.forEach(function (b) {
        var on = b.getAttribute('data-year-sort') === state.mode;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
      });
      if (resetBtn) resetBtn.hidden = !(state.mode !== 'base' || hasFilterValue());
    }
    function refreshUi(f) {
      updateButtons();
      var cap = hitCap ? ' (sok találat — az első ' + seenCount() + ')' : '';
      if (f && f.active) setStatus(f.shown + ' / ' + f.total + ' könyv az évszűrőben' + cap);
      else if (state.mode !== 'base') setStatus((f ? f.total : cardsOf(grid).length) + ' könyv rendezve' + cap);
      else setStatus('');
    }

    function run() {
      setStatus(isSearch ? 'Találatok betöltése…' : 'Összes találat betöltése…');
      ensureLoaded().then(function () { applySort(); refreshUi(applyFilter()); });
    }

    sortBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.getAttribute('data-year-sort');
        state.mode = (state.mode === dir) ? 'base' : dir;
        updateButtons();
        run();
      });
    });
    var filterTimer = null;
    function onFilterInput() { clearTimeout(filterTimer); filterTimer = setTimeout(run, 250); }
    if (minInput) minInput.addEventListener('input', onFilterInput);
    if (maxInput) maxInput.addEventListener('input', onFilterInput);
    if (resetBtn) resetBtn.addEventListener('click', function () {
      state.mode = 'base';
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';
      applySort(); refreshUi(applyFilter());
    });

    // ── AUTO teljes-betöltés: csak KERESÉSEN, több oldalnál, küszöb alatt ──
    // (a kategória stabil, ott csak rendezés/szűréskor töltünk; a keresés
    //  instabil, ezért a vásárlónak alapból a teljes, dedupolt listát adjuk.)
    function reportedCount() {
      var txt = (countEl && countEl.textContent) || document.title || '';
      var m = txt.replace(/ /g, ' ').match(/(\d[\d\s.]*)/);
      if (!m) return null;
      var n = parseInt(m[1].replace(/[\s.]/g, ''), 10);
      return isNaN(n) ? null : n;
    }
    if (isSearch && hasNextPage()) {
      var rc = reportedCount();
      if (rc !== null && rc <= AUTOLOAD_MAX) {
        ensureLoaded().then(function () { applySort(); refreshUi(applyFilter()); });
      }
    }
  }

  // A legördülő azt nevezze meg, amit a sorrendet adó kód TÉNYLEGESEN csinált. A keresésen a szerver nem tudja
  // megkülönböztetni a „nincs sort_by” és a „sort_by=relevance” esetet (mindkettőnél search.sort_by = relevance),
  // ezért ha itt raktáron-elöl rendezünk, a „Raktáron lévők elöl” opciót mi jelöljük ki (change-esemény nélkül).
  function syncSortLabel() {
    var w = mainWrap();
    var sel = w && w.querySelector('#SortBy');
    var opt = sel && sel.querySelector('option[data-bky-stock-first]');
    if (opt && policy().stockFirst && !opt.selected) opt.selected = true;
  }

  // ── Alap-sorrend + vezérlő: első betöltéskor ÉS minden AJAX-frissítés után ugyanígy ──
  function setup() {
    var grid = mainGrid();
    if (grid) {
      stamp(cardsOf(grid), pageNo(window.location.href));
      state.mode = 'base';
      reorder(grid, baseCmp(policy()));
      syncSortLabel();
    }
    bootControls(grid);
  }

  // ── Rendezés-legördülő (kollekció + keresés) ──────────────────────────
  // Capture-fázisban fut, a theme.js saját (kollekció-)kezelője előtt: egyetlen, mindkét oldalon azonos út.
  function onSortChange(e) {
    var sel = e.target;
    if (!sel || sel.id !== 'SortBy' || !sel.closest || !sel.closest('.collection-grid__wrapper')) return;
    e.stopImmediatePropagation();
    var q = new URLSearchParams(window.location.search);
    var v = sel.value;
    if (v) q.set('sort_by', v); else q.delete('sort_by'); // üres érték = „Raktáron lévők elöl” (nincs választott rendezés)
    q.delete('page');
    var s = q.toString();
    window.location.href = window.location.pathname + (s ? '?' + s : '');
  }
  document.addEventListener('change', onSortChange, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('collection:reloaded', setup); // theme.js AJAX-szűrés / vissza-gomb után
  document.addEventListener('shopify:section:load', setup);
})();
